import { Share2, Download, Ticket, ArrowLeft, Pencil, Trash2 } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import type { EventoDetalhe, EquipeMember } from '../types'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { EVENTO_STATUS_BADGE, EVENTO_STATUS_LABEL, type EventoStatusKey } from '../constants'

interface EventDetailHeaderProps {
  evento: EventoDetalhe
  permissoes: EquipeMember['permissoes']
  copied: boolean
  onShare: () => void
  onExport: () => void
  onAddParticipant: () => void
  onEdit: () => void
  onDelete: () => void
  statusBadgeClassName?: string
}

export function EventDetailHeader({
  evento,
  permissoes,
  copied,
  onShare,
  onExport,
  onAddParticipant,
  onEdit,
  onDelete,
}: EventDetailHeaderProps) {
  const navigate = useNavigate()
  const status = (evento.status ?? 'rascunho') as EventoStatusKey

  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center">
          <div className="flex items-center gap-3">
            <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('/eventos')}
          className="h-8 w-8 p-0"
        >
              <ArrowLeft className="h-4 w-4" />
            </Button>
            <div>
              <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-3">
                <h1 className="text-3xl font-bold tracking-tight md:text-4xl">{evento.titulo}</h1>
                <Badge className={EVENTO_STATUS_BADGE[status]}>
                  {EVENTO_STATUS_LABEL[status]}
                </Badge>
              </div>
              <p className="text-muted-foreground">Panorama completo do evento e inscrições</p>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-2 sm:flex-row">
          {permissoes.editar_evento && (
            <Button variant="outline" onClick={onEdit} className="w-full sm:w-auto">
              <Pencil className="mr-2 h-4 w-4" />
              Editar
            </Button>
          )}
          {permissoes.excluir_evento && (
            <Button variant="destructive" onClick={onDelete} className="w-full sm:w-auto">
              <Trash2 className="mr-2 h-4 w-4" />
              Excluir
            </Button>
          )}
          <Button variant="outline" onClick={onShare} className="w-full sm:w-auto">
            <Share2 className="mr-2 h-4 w-4" />
            {copied ? 'Link copiado!' : 'Compartilhar'}
          </Button>
          <Button variant="outline" onClick={onExport} className="w-full sm:w-auto">
            <Download className="mr-2 h-4 w-4" />
            Exportar participantes
          </Button>
          <Button
            className="w-full shadow-md shadow-primary/20 sm:w-auto"
            onClick={onAddParticipant}
          >
            <Ticket className="mr-2 h-4 w-4" />
            Incluir participante
          </Button>
        </div>
      </div>
    </div>
  )
}
